import { toSimpleValidationErrors } from 'laravel-precognition';
export const patchInertiaForm = (method, url, form, validator) => {
    /**
     * The original Inertia submit function.
     */
    const submit = form.submit.bind(form);
    /**
     * Update the errors when validation occurs.
     */
    validator.on('errorsChanged', () => form.clearErrors().setError(toSimpleValidationErrors(validator.errors())));
    /**
     * Patch the form.
     */
    return Object.assign(form, {
        submit(m = {}, u, o) {
            const patchedFunctionCall = typeof m !== 'string';
            o = patchedFunctionCall ? m : o;
            const options = {
                ...o,
                onError: (errors) => {
                    validator.setErrors(errors);
                    if (o.onError) {
                        return o.onError(errors);
                    }
                },
            };
            submit(patchedFunctionCall ? method : m, (patchedFunctionCall ? url : u), options);
        },
    });
};
